import Toast from 'src/components/PlaceBetPanel/components/Toast'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { useDisplayNameHandler } from 'src/hooks/useDisplayNameHandler'

export function DisplayName() {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const {
    displayName,
    setDisplayName,
    isLoading,
    submitDisplayName,
    toastMessage,
    setToastMessage,
    validationError
  } = useDisplayNameHandler()

  return (
    <>
      {toastMessage ? (
        <Toast
          className="toast__inside-container"
          duration={5000}
          message={toastMessage.message}
          onClose={() => {
            setToastMessage(undefined)
          }}
          type={toastMessage.type}
        />
      ) : null}
      <div className="panel-content_section">
        <label>
          {t('Display name')}
          <input
            className={validationError ? 'error' : ''}
            maxLength={20}
            onChange={(e) => {
              setDisplayName(e.target.value)
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !validationError) submitDisplayName()
            }}
            placeholder={t('Display name')}
            type="text"
            value={displayName}
          />
        </label>

        {validationError ? <span className="input__error-message">{validationError}</span> : null}

        <button
          className="default-btn save-btn"
          disabled={isLoading || !!validationError}
          onClick={submitDisplayName}
          type="button"
        >
          <span>{t('Save')}</span>
        </button>
      </div>
    </>
  )
}
